import specificEntry from '../../assets/files/specificEntry.pdf'
import administration from '../../assets/files/administration2.pdf'
import agriculture from '../../assets/files/agriculture2.pdf'
import arts from '../../assets/files/arts2.pdf'
import education from '../../assets/files/education2.pdf'
import engineering from '../../assets/files/engineering2.pdf'
import law from '../../assets/files/law2.pdf'
import medical from '../../assets/files/medical2.pdf'
import sciences from '../../assets/files/sciences2.pdf'
import social from '../../assets/files/social2.pdf'


export const degreeAwardingData = [
    {
    categoryTitle: 'UNIVERSITIES AND OTHER DEGREE-AWARDING INSTITUTIONS',
    contentSection: [
        {
            id: 1,
            contentSectionName: 'All Institutions',
            pageTile: `UNIVERSITIES AND OTHER DEGREE-AWARDING INSTITUTIONS`,
            desc: [
                `Listed below, are the Federal Universities, State and other Degree Awarding institutions in Nigeria. The abbreviations indicate against them are the ones used in 
                 thIs brochure.`,
            ],
            sections: [
                {
                    id: 1,
                    sectionTitle: `A. FEDERAL UNIVERSITIES`,
                    contents: [
                        {
                            abbreviation: `ABU`,
                            instName: `Ahmadu Bello university.`,
                            instAddress: `Zaria`,
                            instPhone: [`069-550811`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ABUJA`,
                            instName: `University of Abuja,`,
                            instAddress: `P.M.B. 117, Gwagwalada F.C.T Abuja.`,
                            instPhone: [`09-8821380`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AAAU`,
                            instName: `African AvIation and Aerospace University,`,
                            instAddress: `Fct, Abuja`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BAYERO`,
                            instName: `Bayero University`,
                            instAddress: `P.M.B 3011, Kano`,
                            instPhone: [`064-666021-3`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BAUCHI`,
                            instName: `Abubakar Tatawa Balewa University`,
                            instAddress: `P.M.B. 0248, Bauchi.`,
                            instPhone: [`077-543500-1`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BENIN`,
                            instName: `Universitv of Benin`,
                            instAddress: `P.M.B 1154. Benin City`,
                            instPhone: [``],
                            email: [`registrar@uniben.edu`],
                            website: [``]
                        },
                        {
                            abbreviation: `CALABAR`,
                            instName: `Universitv of Calabar`,
                            instAddress: `P.M.B 1115,Calabar`,
                            instPhone: [`087-232695`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-DUTSE`,
                            instName: `Federal University, Dutse`,
                            instAddress: `Jigawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-DUTSINMA`,
                            instName: `Federal University. DUTSINMA,`,
                            instAddress: `KATSINA STATE`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-GASHUA`,
                            instName: `Federa Universitv. Gashua`,
                            instAddress: `Yobe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-GUSAU`,
                            instName: `Federal University, Gusau`,
                            instAddress: `Zamfara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-KASHERE`,
                            instName: `rederal University, kashere`,
                            instAddress: `Gombe state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-KEBBI`,
                            instName: `Federal University, Birnin-Kebbi`,
                            instAddress: `Birnin-Kebbi, Kebbi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-LAFIA`,
                            instName: `Federal University, Latia`,
                            instAddress: `P.M.B. 146, Lafia, Nasarawa State.`,
                            instPhone: [``],
                            email: [`info@fulafia.edu.ng.`],
                            website: [`www.fulafia.edu.ng`]
                        },
                        {
                            abbreviation: `FED-LOKOJA`,
                            instName: `Federal University, Lokoja`,
                            instAddress: `Kogi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AEFUNA`,
                            instName: `Alex Ekwueme Federal University, Ndufu-Alike`,
                            instAddress: `Ebonyi State,`,
                            instPhone: [``],
                            email: [`chinedum.nwajiuba@funai.edu.ng`, `vc@funai.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-OTUOKE`,
                            instName: `Federal University, Otuoke`,
                            instAddress: `Bayelsa state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-OYE EKITI`,
                            instName: `Federal University, Oye-Ekiti`,
                            instAddress: `Ekiti State`,
                            instPhone: [`08062434663`],
                            email: [`registrar@fuoye.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `FED-WUKARI`,
                            instName: `Federal University, Wukari`,
                            instAddress: `200 Katsina-Ala Road, P.M.B 1020, Wukari Taraba State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IBADAN`,
                            instName: `University Of Ibadan`,
                            instAddress: `Ibadan, Oyo state`,
                            instPhone: [`400550-614`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ILORIN`,
                            instName: `University of Ilorin`,
                            instAddress: `P.M.B .1515, Ilorin`,
                            instPhone: [`031-221691`,`031-221551-3`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `JOS`,
                            instName: `University of Jos`,
                            instAddress: `P.M.B. 2084, Jos Plateau State`,
                            instPhone: [`073-610936`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LAGOS`,
                            instName: `University of Lagos`,
                            instAddress: `Akoka, Lagos State`,
                            instPhone: [`01-7432778`],
                            email: [`admissions@unilag.edu.ng`],
                            website: [`www.unilag.edu.ng`]
                        },
                        {
                            abbreviation: `MAIDUGURI`,
                            instName: `University of Maiduguri`,
                            instAddress: `P.M.B 1069, Maiduguri,`,
                            instPhone: [`076-231730`,`232949`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MAKURDI`,
                            instName: `Joseph Sarwuan Tarka University.`,
                            instAddress: `Makurdi, Benue State.`,
                            instPhone: [`044-533204-5`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NAUB`,
                            instName: `wigerian Army university`,
                            instAddress: `Biu,  Borno state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NDA`,
                            instName: `Nigerian Detence Academy`,
                            instAddress: `P.M.B. 2109, Kaduna, Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OAU`,
                            instName: `Obafemi Awolowo University'`,
                            instAddress: `lle-Ife, Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PHC`,
                            instName: `University of Port-Harcourt`,
                            instAddress: `P.M.B 5323, Port-Harcourt, Rivers State`,
                            instPhone: [`084.230890_9`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POL-ACAD`,
                            instName: `Nigerian Police Academy Wudil`,
                            instAddress: `Kano. Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UDU`,
                            instName: `Usmanu Danfodio University.`,
                            instAddress: `P.M.B. 2346. Sokoto`,
                            instPhone: [`060234039`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNIZIK`,
                            instName: `Nnamdi Azikiwe University`,
                            instAddress: `P.M.B 5025, Awka, Anambra State.`,
                            instPhone: [`046-55082`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNN`,
                            instName: `Universitv of Nigeria Nsukka.`,
                            instAddress: `Enugu State`,
                            instPhone: [`07088617000`],
                            email: [`unn@unn.edu.ng`],
                            website: [`www.unn.edu.ng`]
                        },
                        {
                            abbreviation: `UYO`,
                            instName: `University of Uyo`,
                            instAddress: `P.M.B. 1017, Uyo, Akwa-ibom state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        }
                    ]
                },
                {
                    id: 2,
                    sectionTitle: `B. FEDERAL UNIVERSITIES OF AGRICULTURE`,
                    contents: [
                        {
                            abbreviation: `FUNAAB`,
                            instName: `Federal University of Agriculture`,
                            instAddress: `P.M.B. 2240, Abeokuta.`,
                            instPhone: [`0833918405`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FUA-ZURU`,
                            instName: `Federal Universit of Agriculture`,
                            instAddress: `Zuru, Kebbi state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UMUDIKE`,
                            instName: `Michael Okara University of Agriculture.`,
                            instAddress: `Umudike, P.M.B 7267, Umuahia Abia State.`,
                            instPhone: [`052-440555`],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 3,
                    sectionTitle: `C. FEDERAL UNIVERSITIES OF TECHNOLOGY`,
                    contents: [
                        {
                            abbreviation: `AFIT-DEG`,
                            instName: `Air Force Institute of Technology, Nigerian Air Force.`,
                            instAddress: `P.M.B. 2104, Mando, Kaduna`,
                            instPhone: [`07029306014`],
                            email: [`registrar@afit.edu.ng.`],
                            website: [`www.atit.edu.ng`]
                        },
                        {
                            abbreviation: `FUPRE`,
                            instName: `Federal University of Petroleum Resources`,
                            instAddress: `P.M.B.1221, Effurun Delta State, Nigeria`,
                            instPhone: [`fupreifo@ gmail.com`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FUTA`,
                            instName: `Federal University of Technology`,
                            instAddress: `P.M.B 1526. Akure. Ondo State.`,
                            instPhone: [`034-243490-4`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FUTIA`,
                            instName: `Federal University of Technology.`,
                            instAddress: `Ikot-Abasi, Akwa bom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FUTO`,
                            instName: `Federal University of Technology`,
                            instAddress: `P.M.B. 1526, Owerri.`,
                            instPhone: [`083-230974`,`233456`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FUT-BABURA`,
                            instName: `Federal University of Technology`,
                            instAddress: `Babura, Jigawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MINNA`,
                            instName: `Federal University of Technology`,
                            instAddress: `P.M.B 65, Minna.`,
                            instPhone: [`066-222397`,`222887`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MODIBO`,
                            instName: `Modibbo Adama University`,
                            instAddress: `P.M.B 206, Yola, Adamawa state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MARITIME-UNI`,
                            instName: `Nigeria Maritime University`,
                            instAddress: `Okerenkoko, Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 4,
                    sectionTitle: `D. FEDERAL UNIVERSITIES OF HEALTH SCIENCES`,
                    contents: [
                        {
                            abbreviation: `FUHSA`,
                            instName: `Federal University of Health Sciences, Azare`,
                            instAddress: `Bauchi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FUHSO`,
                            instName: `Federal University of Health Sciences, Otukpo`,
                            instAddress: `Benue State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FUHS-ILA`,
                            instName: `Federal University of Health Sciences, ila-Orangun`,
                            instAddress: `Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DANUMS`,
                            instName: `David Iweze Umahi Federal University 0F Medical Sciences, Uburu`,
                            instAddress: `Ebonyi state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 5,
                    sectionTitle: `E. STATE UNIVERSITIES`,
                    contents: [
                        {
                            abbreviation: `AAUA`,
                            instName: `Adekunle Ajasin University`,
                            instAddress: `P.M.B 01, Akungba-Akoko, Ondo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AAU`,
                            instName: `Ambrose Ali University`,
                            instAddress: `P.M.B. 14. Ekooma. Fdo State.`,
                            instPhone: [`055-98448`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ABSU`,
                            instName: `Abla state University, oturu.`,
                            instAddress: `P.M.B. 2000 Okigwe, Abia State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ADSU`,
                            instName: `Adamawa State Universitv. Mubi.`,
                            instAddress: `P.M.B. 25, Mubi, Adamawa state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AKSU`,
                            instName: `Akwa loom state University, Ikot-Akpaden`,
                            instAddress: `Mkpat Enin P.M.B. 1167 Uyo. Akwa lbom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BASU`,
                            instName: `Bauchi State University, Gadau`,
                            instAddress: `Bauchi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BOSU`,
                            instName: `Borno state University, Maiduguri.`,
                            instAddress: `Borno State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BSU`,
                            instName: `Benue State UniversitY`,
                            instAddress: `P.M.B. 102119, Makurdi Benue State`,
                            instPhone: [`044-533811`, `531162`, `532550`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CRUTECH`,
                            instName: `cross River University of Technology`,
                            instAddress: `P.M.B. 1123, Calabar, Cross River State.`,
                            instPhone: [`087-232303`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DELSU`,
                            instName: `Delta state University`,
                            instAddress: `P.M.B 1 Abraka Delta State`,
                            instPhone: [`054-66009`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DELSUT`,
                            instName: `Delta State University of Science and Technology`,
                            instAddress: `Ozoro, Delta state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DOU`,
                            instName: `Dennis Usadebay university`,
                            instAddress: `Asaba, Delta State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EBSU`,
                            instName: `Ebonyi state University,`,
                            instAddress: `P.M.B.53. Abakaliki, Ebonyi State.`,
                            instPhone: [`043-221337`, `043-221093`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EUI`,
                            instName: `Edo University, Iyamho.`,
                            instAddress: `Fdo State`,
                            instPhone: [`08055657745`],
                            email: [`vc@edouniversity.edu.ng`],
                            website: [`www.edouniversity.eau.ng`]
                        },
                        {
                            abbreviation: `EKSU`,
                            instName: `Ekiti State University, Ado-Ekiti`,
                            instAddress: `P.M.B 5363, Ado- Ekiti, Ekiti State`,
                            instPhone: [`030-250370`, `250711`,`250026`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GSU`,
                            instName: `Gombe state University.`,
                            instAddress: `P.M.B. 27, Tudun wada, Gombe. combe state`,
                            instPhone: [`072-22091`, `072-221097`],
                            email: [`vegsu@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `GSUST`,
                            instName: `Gombe State University of Science and Technology, Kumo`,
                            instAddress: `Gombe State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IMSU`,
                            instName: `Imo State University,`,
                            instAddress: `P.M.B. 2000 Owerri, Imo state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KASU`,
                            instName: `Kaduna state University`,
                            instAddress: `Tatawa Balewa Way, P.M.B. Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KASU-KABBA`,
                            instName: `Kogi state University, kabba,`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PAAU`,
                            instName: `Prince Abubakar Audu University`,
                            instAddress: `P.M.B. 1008, Anyigba Kogi State`,
                            instPhone: [`009-87-762538-275`,`08035959687`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UMVIYUK`,
                            instName: `Umaru Musa Yaradua University`,
                            instAddress: `P.M.B.2218. Katsina`,
                            instPhone: [``],
                            email: [`Info@umyu.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `SLUK`,
                            instName: `Sule Lamido University`,
                            instAddress: `P.M.B. 048, Katin Hausa, Jigawa state.`,
                            instPhone: [``],
                            email: [`ayribadu@yahoo.com`],
                            website: [`www.jsu.edu.ng`]
                        },
                        {
                            abbreviation: `KWASU`,
                            instName: `kwara state University, Malete`,
                            instAddress: `Malete, Kwara stare.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LASU`,
                            instName: `Lagos State university, Ojo`,
                            instAddress: `P.M.B. 1087, Apapa, Lagos.`,
                            instPhone: [`01-884043,884048`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LAPAI`,
                            instName: `Ibrahim Badamasi Babangida University. Lapai.`,
                            instAddress: ``,
                            instPhone: [`066-220646`, `08036650914`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NASARAWA`,
                            instName: `Nasarawa state University, keffi`,
                            instAddress: `P.M.B. 1022, Keffi, Nasarawa State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MAITAMA`,
                            instName: `Yusuf Maitama Sule University, Kano`,
                            instAddress: `Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NDU`,
                            instName: `Niger Delta University`,
                            instAddress: `P.M.B. 071, Wilberforce Island, Bayelsa State`,
                            instPhone: [`089-490484`, `089-490899`, `490900`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OOU`,
                            instName: `Olabisi Onabanio University.`,
                            instAddress: `P.M.B. 2002, Ago-Iwoye, Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PLASU`,
                            instName: `Plateau State University, Bokkos`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [`longpoec@yahoo.cominfo!@plasu.edu.ng`],
                            website: [`www.plasu.edu.ng`]
                        },
                        {
                            abbreviation: `RSU`,
                            instName: `Rivers State University`,
                            instAddress: `P.M.B. 5080. Port-harcourt. Rivers State`,
                            instPhone: [`084-338508`, `335823`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNI-AFRICA`,
                            instName: `The University of Africa, Toru-Orua.`,
                            instAddress: `Bavelsa State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNI-ILESA`,
                            instName: `Universitv of llesa`,
                            instAddress: `Ilesa osun state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNIOSUN`,
                            instName: `Osun state University`,
                            instAddress: `Osogbo, Osun State`,
                            instPhone: [`035203095`, `0305203097`],
                            email: [``],
                            website: [`www.uniosun.org`]
                        },
                        {
                            abbreviation: `COOU`,
                            instName: `Chukwuemeka Odumegwu Olukwu Universitv. igbariam,`,
                            instAddress: `P.M.B. 02. igbariam Anambra state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SOSU`,
                            instName: `Sokoto State University`,
                            instAddress: `Birnin Kebbi Road P.M.B. 2143 Sokoto. Sokoto State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TSUJ`,
                            instName: `Taraba State University, Jalingo`,
                            instAddress: `P.M.B. 116, Jalingo Taraba State Nigeria`,
                            instPhone: [``],
                            email: [`tsuja@@gamail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `TECH-IBADAN`,
                            instName: `First Technical University, Ibadan`,
                            instAddress: `Ibadan, Oyo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UDA`,
                            instName: `Universitv of Delta, Agbor`,
                            instAddress: `Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `YSU`,
                            instName: `Yobe State University`,
                            instAddress: `Sir Kashim Ibrahim Road P.M.B, 1144 Damaturu. Yobe state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ZAMFARA`,
                            instName: `Zamfara state University,`,
                            instAddress: `Sokoto Road. Talata Matara, Zamfara State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 6,
                    sectionTitle: `F. STATE UNIVERSITIES OF TECHNOLOGY`,
                    contents: [
                        {
                            abbreviation: `BOUEDST`,
                            instName: `Bamidele Olumilua University of Education, Science and Technology`,
                            instAddress: `Ikere-Ekiti, Ekiti State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CUST`,
                            instName: `Confluence University of Science and Technology`,
                            instAddress: `Osara. Kogi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ESUTECH`,
                            instName: `Enugu State University of Science and Technology`,
                            instAddress: `P.M.B 1660, Enugu Enugu State`,
                            instPhone: [`042-451319`, `451253`, `451244`, `451264`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KSUSTA`,
                            instName: `Kebbi State University of Science and Technology`,
                            instAddress: `Aliero, Kebbi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KUST`,
                            instName: `Kano University of Science and Technology, Wudil c/o Kano State Coll. of Art, Science and Remedial Studies`,
                            instAddress: `P.M.B, 3244, Kano`,
                            instPhone: [`064-241175`,`241149`,`648029`,`241175`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LASUSTECH`,
                            instName: `Lagos State University of Science and Technology, Ikorodu`,
                            instAddress: `Ikorodu, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LAUTECH`,
                            instName: `Ladoke Akintola University of Technology`,
                            instAddress: `P.M.B. 4000, Ogbomoso, Ovo State.`,
                            instPhone: [`038-710340`, `710776`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OAUSTECH`,
                            instName: `Olusegun Agacu Universitv of Science and Technology`,
                            instAddress: `Okitinuna. Ondo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 7,
                    sectionTitle: `G. STATE UNIVERSITIES OF EDUCATION`,
                    contents: [
                        {
                            abbreviation: `EAU`,
                            instName: `Emmanuel Alavande University of Education Oyo`,
                            instAddress: `Oyo, Oyo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IAUED`,
                            instName: `gnatius Aluru University of Education, Rumuolumeni.`,
                            instAddress: `P.M.B. 5047. Port Harcourt, Rivers State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LASUED`,
                            instName: `Lagos State Universitv of Education. Oto/ijanikin`,
                            instAddress: `Oto/ijanikin, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NUEM`,
                            instName: `Niger State University of Education`,
                            instAddress: `Minna, Niger State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SSUET`,
                            instName: `Shehu Shagari University of Education`,
                            instAddress: `Tambuwal, Sokoto state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TASUED`,
                            instName: `Tai Solarin Universitv of Education Ijagun`,
                            instAddress: `P.M.B, 2118 ijebu-ode Ogun State.`,
                            instPhone: [`037-432770`, `431547`, `431994`],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 8,
                    sectionTitle: `H. STATE UNIVERSITIES OF MEDICAL SCIENCES`,
                    contents: [
                        {
                            abbreviation: `BMU`,
                            instName: `Bayelsa Medical University`,
                            instAddress: `imgbi Roaa, Yenagoa, P.M.B. 178, Bayelsa State,`,
                            instPhone: [``],
                            email: [``],
                            website: [`www.bmu.edu.ng`]
                        },
                        {
                            abbreviation: `OSUMS`,
                            instName: `Undo State University of Medical sciences`,
                            instAddress: `Lale Road, Undo, Ondo State.`,
                            instPhone: [`08023347828`],
                            email: [`vc@osums.edu.ng`, `feokonofua@yahoo.co.uk`],
                            website: [`www.osums.edu.ng`]
                        },
                        {
                            abbreviation: `SUMAS`,
                            instName: `State University of Medical and Applied Sciences`,
                            instAddress: `Ibgo eno, Enugu state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 9,
                    sectionTitle: `I. STATE UNIVERSITIES OF AGRICULTURE`,
                    contents: [
                        {
                            abbreviation: `UAGRIC-IMO`,
                            instName: `University of Agriculture and Environmental Sciences`,
                            instAddress: `Umuagwo, imo state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        }
                    ]
                },
                {
                    id: 10,
                    sectionTitle: `J. PRIVATE UNIVERSITIES`,
                    contents: [
                        {
                            abbreviation: `ABUAD`,
                            instName: `Afe-Babalola UNiversity, Ado-Ekiti`,
                            instAddress: `KM8.5 Ate Babalola Wav. Ado-Ekiti Ekiti State, Nigeria`,
                            instPhone: [`+234-80-38521163`, `+234-80-33509150`, `+234-80-127772121`, `+234-80-127772121`, `+234-70-39647532`],
                            email: [``],
                            website: [`www.abuad.eau.ng`]
                        },
                        {
                            abbreviation: `ACHIEVERS`,
                            instName: `Achievers university`,
                            instAddress: `Km 1, Idasen-Ute, P.M.B. 1030, Owo, Ondo State.`,
                            instPhone: [`08067622251`, `07062815510`],
                            email: [`vc@achievers.edu.ng`, `registrar@achievers.edu.ng`, `info@achievers.edu.ng`],
                            website: [`www.achievers.edu.ng`]
                        },
                        {
                            abbreviation: `ADUN`,
                            instName: `Admiralty University of Nigeria`,
                            instAddress: `Ibusa, Delta State`,
                            instPhone: [`09072229992`, `09072229993`],
                            email: [`info@adunedu.org`],
                            website: [`www.adun.eau.ng`]
                        },
                        {
                            abbreviation: `AL-ANSAR`,
                            instName: `Al-Ansar University, Maiduguri`,
                            instAddress: `KM 5, Maiduguri-Gubjo Road, Borno State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ANCHOR-UNI`,
                            instName: `Anchor University, Ayobo`,
                            instAddress: `Ayobo, Lagos state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `АTIВА`,
                            instName: `Atiba Universitv, Oyo`,
                            instAddress: `Oyo, Oyo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AUGUSTINE`,
                            instName: `Augustine University Ibara, (The Catholic University of Lagos Archdiocese)`,
                            instAddress: `P.M.B. 1010. Tara-Epe. Lagos State`,
                            instPhone: [``],
                            email: [`vc@augustineuniversitv.edu.ng`, `registrar@augustineuniversity.edu.ng`, `admin@ augustineuniversity.edu.ng`],
                            website: [`www.augustineuniversitv.edu.ng`]
                        },
                        {
                            abbreviation: `AL-HIKMAH`,
                            instName: `Al- Hikman University`,
                            instAddress: `Adeta Road, Adewole Housing Estate P.O.BOX 3340. orin. Kwara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ALETHEIA`,
                            instName: `Alethela University, AgO IwOye`,
                            instAddress: `AgO IwOye, Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AMOU`,
                            instName: `AI-MuhIbban Open University, Kubwa`,
                            instAddress: `Kubwa, Abuja.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `APU`,
                            instName: `Ahman Pategi University, Patigi`,
                            instAddress: `Patigi, KwAra StATe`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AUE`,
                            instName: `Adeleke University, Ede`,
                            instAddress: `Ede, Osun state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AUN`,
                            instName: `American University of Nigeria`,
                            instAddress: `LamIdo zubalru way ,rold by-pass, P.M.B. 2250, Yola, Adamawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AJAYI`,
                            instName: `Ajavi Crowther University`,
                            instAddress: `P.M.B. 10066, Oyo. Oyo state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ARTHUR-JARVIS`,
                            instName: `Arthur Jarvis University`,
                            instAddress: `Akpabuyo, Cross river state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AUST`,
                            instName: `African University of Science and Technology`,
                            instAddress: `Garki, FCT - Abuja.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AVE-MARIA`,
                            instName: `Ave. Maria University`,
                            instAddress: `Piyanko Nasarawa state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AZMAN`,
                            instName: `Azman University.`,
                            instAddress: `Kano, Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ВАВСОСК`,
                            instName: `Babcock University, Ilishan-Remo`,
                            instAddress: `P.M.B. 21244, Ikeja.`,
                            instPhone: [`037-432799`, `6301489`],
                            email: [`babcock@infoweb.abs.net`],
                            website: [``]
                        },
                        {
                            abbreviation: `BAZE`,
                            instName: `Baze University`,
                            instAddress: `Federal capital territory, Abuja`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BAUK`,
                            instName: `Baba Ahmed University, Kano`,
                            instAddress: `No. 306, Sharada Industrial Estate, Phase 1 Kano state`,
                            instPhone: [`+234803348966`, `†2347037505336`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BCU`,
                            instName: `British Canadian University`,
                            instAddress: `Kakum, Obudu, Cross River State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BELLS`,
                            instName: `Bells University of technology`,
                            instAddress: `KM 8, latriDIROKOoko Road, P..B. 1015, Ota Ogun state.`,
                            instPhone: [`017949216`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BINGHAM`,
                            instName: `Bingham University`,
                            instAddress: `P.M.B. 005 Karu, Nasarawa State`,
                            instPhone: [`09-6/20785`, `08055024585`],
                            email: [`binghamuniversity@Yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `BIU`,
                            instName: `Benson dahosa University`,
                            instAddress: `P.M.B. 1100 Benin Citv. Edo State`,
                            instPhone: [`052-253764`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BOUFDST`,
                            instName: `Bamidele Olumilua University of cducation, Science and Technology`,
                            instAddress: `Ikere-EKItI, ekiti State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BOWEN`,
                            instName: `Bowen University`,
                            instAddress: `P.M.B. 284 Iwo, Osun state`,
                            instPhone: [``],
                            email: [`into@bowenuniversity_educ.org`],
                            website: [`www.bowenuniversity eau.org`]
                        },
                        {
                            abbreviation: `CALEB`,
                            instName: `Caleb University`,
                            instAddress: `KM 15. Ikorodu- Itokin Road. Imota, P.MP.B. 21238, Ikeja, Lagos State.`,
                            instPhone: [`01-8517711.01`, `764712`],
                            email: [`info@calebuniversity.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `CANADIAN -UNI`,
                            instName: `Canadian University of Nigeria`,
                            instAddress: `Abuja`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CARITAS`,
                            instName: `Caritas University`,
                            instAddress: `P.M.B. 01784, Enugu, Enugu State`,
                            instPhone: [`08063589115`, `042-308921`],
                            email: [`caritasuniv@vahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `CCU`,
                            instName: `Capital City University`,
                            instAddress: `warawa, Kano state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CHRISTOPHER`,
                            instName: `christopner university`,
                            instAddress: `Mowe, Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CLIFFORD`,
                            instName: `Clifford University, Owerrintta`,
                            instAddress: `Isiala Ngwa, Abia State. P.M.B. 8001, Aba`,
                            instPhone: [`+2347034263550`, `+2348039385198`],
                            email: [`vc@clifforduni.edu.ng`, `Registrar@clifforduni.edu.ng`],
                            website: [`www.clifforduni.edu.ng`]
                        },
                        {
                            abbreviation: `CRAWFORD`,
                            instName: `Crawtord University`,
                            instAddress: `Igbesa, Faith City, KLM 8, Atan - Agbara Road P. M. B. 2001, |gbesa, Ogun State, Nigeria`,
                            instPhone: [`234-806296600`,`8023003436`,`8035456352`, `8055434412`],
                            email: [`info@crawtorduniversity.eau.ng`],
                            website: [`www.crawtorduniversitv.edu.ng`]
                        },
                        {
                            abbreviation: `CHRISLAND`,
                            instName: `Chrisland University`,
                            instAddress: `Owode, Ogun state KM 5 Ajebo Road, Abeokuta, P.M.B. 2131, Abeokuta, Ogun State`,
                            instPhone: [`08023671737`, `08132663928`],
                            email: [`admission@chrislanduniversitv.edu.ng`, `chrislandadmin@chrislanduniversity.edu.ng`],
                            website: [`www.chrislanduniversitv.edu.ng`]
                        },
                        {
                            abbreviation: `CUAB`,
                            instName: `Crescent University`,
                            instAddress: `KIVI S Avetoro Road, Latenwa P.M.B. 2104, sapon, Abeokuta, Ogun State`,
                            instPhone: [`08030644731`, `07098133287`],
                            email: [`into@crescent-universitv.edu.ng`, `admissions@crescent-university.edu.ng`],
                            website: [`www.crescent-university.edu.ng`]
                        },
                        {
                            abbreviation: `COAL-CITY`,
                            instName: `Coal City University.`,
                            instAddress: `KM 3 Enugu/Abakaliki Expressway, Emene, Enugu state`,
                            instPhone: [`08115757997`, `08115/57998`],
                            email: [`info@coalcitvuniversity.edu.ng`],
                            website: [`www.coalcityuniversitv.edu.ng`]
                        },
                        {
                            abbreviation: `COSMOPOLITAN`,
                            instName: `Cosmopolitan University`,
                            instAddress: `FCT, Abuja`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COVENANT`,
                            instName: `covenant Universitv, canaan Land`,
                            instAddress: `KM 10, Idiroko Road, P.M.B. 1023 Ota, Ogun State`,
                            instPhone: [`01/7947546-8`, `7900724`],
                            email: [`registrar@ covenantuniversity.org`],
                            website: [``]
                        },
                        {
                            abbreviation: `CROWN-HILL`,
                            instName: `Crown Hill University`,
                            instAddress: `Eiyenkorin, Airport Road, P.M.B. 1605, Ilorin, Kwara State.`,
                            instPhone: [`08033906774`, `08158314833`],
                            email: [`registrar@crownhilluniversity.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `CUN`,
                            instName: `Claretian University`,
                            instAddress: `Nekede, Imo state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DOMINICAN-UNI`,
                            instName: `Dominican University`,
                            instAddress: `Ibadan, Oyo State`,
                            instPhone: [`+2349030001712`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DOMINION`,
                            instName: `Dominion University`,
                            instAddress: `Ibadan, Oyo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDWIN CLARK`,
                            instName: `Edwin Clark University`,
                            instAddress: `kiagbodo. Delta State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDUSOKO`,
                            instName: `Edusoko University, Bida`,
                            instAddress: `Bida, Niger State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EKO-UNI`,
                            instName: `Eko University of Medicine and Health Sciences`,
                            instAddress: `Ijanikin. Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ELIZADE`,
                            instName: `Elizade University`,
                            instAddress: `Ilara-Mokin, Ondo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EL-AMIN`,
                            instName: `El-amin University,`,
                            instAddress: `Minna, Niger State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FUT-DAURA`,
                            instName: `Federal University of Transportation`,
                            instAddress: `Daura, Katsina State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KOMU`,
                            instName: `Kingsley Ozumba (K.O) Mbadiwe University`,
                            instAddress: `Ogboko Ideato South LGA., pM B 006 Oru Imo State`,
                            instPhone: [``],
                            email: [`registrar@epu.edu.ng`],
                            website: [`www.easternpalmuniversity.edu.ng`]
                        },
                        {
                            abbreviation: `EUN`,
                            instName: `European Universitv of Nigeria`,
                            instAddress: `Duboyi Abuja, FCT.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EVANGEL`,
                            instName: `Evangel University, Okpoto.`,
                            instAddress: `Okpoto, Ebonvi State`,
                            instPhone: [`08139343306`,`08076283514`, `08098421931`],
                            email: [`iukalu@yahoo.com`, `yc@evangeluniv.edu.ns`],
                            website: [``]
                        },
                        {
                            abbreviation: `FOUNTAIN`,
                            instName: `Fountain University`,
                            instAddress: `Oke-Osun, P.M.B 4491, Osogbo`,
                            instPhone: [`08034928614`, `035-2074335`],
                            email: [`enquiries@fountainuniversity.org`],
                            website: [``]
                        },
                        {
                            abbreviation: `FRANCO`,
                            instName: `Franco British International University.`,
                            instAddress: `Kaduna, Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GOUU`,
                            instName: `Godtrev Okove University`,
                            instAddress: `Ugwuomu- Nike P.M.B. 01014 Thinkers' Comer, Enugu, Nigeria`,
                            instPhone: [`048-482891`],
                            email: [``],
                            website: [`www.og-uni-enugu.net`]
                        },
                        {
                            abbreviation: `GREENFIELD`,
                            instName: `Greentield University`,
                            instAddress: `Kasarami, Kaduna, Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GERAR`,
                            instName: `Gerar University of Medical Sciences`,
                            instAddress: `Imope-Ode, Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GREGORY`,
                            instName: `Gregory University`,
                            instAddress: `Uturu, Abia State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HENSARD`,
                            instName: `Hensard University`,
                            instAddress: `Toru Orua, Bayelsa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ICONIC-OU`,
                            instName: `Iconic Open Universitv.`,
                            instAddress: `Sokoto, Sokoto State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IGBINEDION`,
                            instName: `Igbinedion University, Okada`,
                            instAddress: `69, Airport Road, P.M.B. 0006, Benin City, Edo State`,
                            instPhone: [`052-254942`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ISTIGAMA`,
                            instName: `Al-Istigama University`,
                            instAddress: `Sumaila, Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HALLMARK`,
                            instName: `Hallmark University`,
                            instAddress: `Ijebu-Itele, Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HAVILLA`,
                            instName: `Havilla UniversitY.`,
                            instAddress: `Nde-Ikom Cross-River State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HUDA`,
                            instName: `Huda University`,
                            instAddress: `Gusau, Zamfara state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HUSTECH`,
                            instName: `Hillside University of Science and Technology`,
                            instAddress: `Okemesi, Ekiti State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `JABU`,
                            instName: `Josepn Ayo babalola University`,
                            instAddress: `Ikeji-Arakeji, Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `JEWEL`,
                            instName: `Jewel University`,
                            instAddress: `Gombe, Gombe state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AL-QALAM`,
                            instName: `Al-Qalam University`,
                            instAddress: `Dutsinia Roda, P.m.b 2137, Katsina state`,
                            instPhone: [`065-434785`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LANDMARK`,
                            instName: `Landmark University`,
                            instAddress: `umu-Aran, Kwara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LCITY`,
                            instName: `Lead city University`,
                            instAddress: `Oba Otudeko Avenue P.O.BOX 30678, Secretariat o Gate Area. Ibadan`,
                            instPhone: [`02-7510681`],
                            email: [`registrar@llcu.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `LEGACY`,
                            instName: `Legacy University, Okija`,
                            instAddress: `Okija, Anambra state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LUX-MUNDI`,
                            instName: `LuX Mundi University, Ibeku`,
                            instAddress: `Umuaha, Abia State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KHAIRUN`,
                            instName: `Khalita Isyaku Rabiu University`,
                            instAddress: `Gadon kaya city Gate, kano, Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KOLADAISI`,
                            instName: `Koladaisi University`,
                            instAddress: `Ibadan, Oyo State.`,
                            instPhone: [``],
                            email: [`vc@koladaisiuniversity.edu.ng`, `registrar@koladaisiuniversity.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `KUM`,
                            instName: `Khadila University`,
                            instAddress: `Majia, Jigawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KKU`,
                            instName: `karl kumm University,`,
                            instAddress: `vom, Plateau State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KWARARAFA`,
                            instName: `KWARARAFA University, Wukari`,
                            instAddress: `P.M.B. 1019, Wukari, Taraba State.`,
                            instPhone: [`08036023768`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MADONNA`,
                            instName: `Madonna University`,
                            instAddress: `P.M.B O5. Fele. Rivers State`,
                            instPhone: [`046-463724`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MAAUN`,
                            instName: `Maryam Abacha American University of Nigeria`,
                            instAddress: `Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MADUKA`,
                            instName: `maduka University`,
                            instAddress: `Ekwegbe, Nsukka, Enugu State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MARANATHA`,
                            instName: `Maranatha University`,
                            instAddress: `KIm 47, Lekki - Epe Expressway, Ibeju Lekki, Lagos state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MC-IBRU`,
                            instName: `Michael and Cecilia Ibru University`,
                            instAddress: `Ibru Village Agbarha - otor, Ughelli North, Delta State`,
                            instPhone: [`09030874725`, `08174485808`, `09096119414`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MCPHERSON`,
                            instName: `McPherson University`,
                            instAddress: `Seriki Sotayo, Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MERCY-MED-UNI`,
                            instName: `Mercy Medical University`,
                            instAddress: `IWO, Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MEWAR`,
                            instName: `Mewar University Nigeria`,
                            instAddress: `Masaka, Nasarawa state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MIVA`,
                            instName: `Miva Open University`,
                            instAddress: `Utako, Abuja`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MKAR`,
                            instName: `University ou Mkar`,
                            instAddress: `P.M.B. U17 Gboko, Benue State`,
                            instPhone: [`044-470631`],
                            email: [`mkaruni@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `MK-UNI`,
                            instName: `Muhammed Kamalud-Deen University`,
                            instAddress: `Ilorin, Kwara state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MLU`,
                            instName: `Ilargaret Lawrence university`,
                            instAddress: `Galilee, Delta State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MOUNTAIN TOP`,
                            instName: `Mountain Top University`,
                            instAddress: `Makogi/Oba, Ogun state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MUDIAME`,
                            instName: `Mudiame University.`,
                            instAddress: `Irrua, Edo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NBU`,
                            instName: `Nigerian British University.`,
                            instAddress: `Asa Abia state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NEWGATE`,
                            instName: `Newgate University`,
                            instAddress: `Minna, Niger state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NOVENA`,
                            instName: `Novena University. Ogume`,
                            instAddress: `P.M.B. 2 kwale, Delta state`,
                            instPhone: [`08033302376`, `08037167418`, `08066568533`, `080624111131`, `08082852293`, `01-4973603`, `104977717`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NUTECH`,
                            instName: `Nigerian University of Technology and Management.`,
                            instAddress: `Victoria Island, Lagos state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NILE`,
                            instName: `Nile University of Nigeria`,
                            instAddress: `Plot 681 Cadastral Zone Coo. Research & Institution Area Airport Road Bypass, Abuja`,
                            instPhone: [`08138616589`],
                            email: [``],
                            website: [`www.ntnu.edu.ng`]
                        },
                        {
                            abbreviation: `NOK`,
                            instName: `NOK University`,
                            instAddress: `Kachia, Kaduna state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NUS`,
                            instName: `Northwest University`,
                            instAddress: `Sokoto, Sokoto State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OBONG`,
                            instName: `Obong University, Obong, Ntak`,
                            instAddress: `P.O.BOX 25, Abak Akwa bom State`,
                            instPhone: [`08028915795`],
                            email: [``],
                            website: [`www.obonguniversity.net`]
                        },
                        {
                            abbreviation: `ODUDUWA`,
                            instName: `Oduduwa University, Ipetumodu`,
                            instAddress: `P.M.B. 5533 Ile Ife Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PAMO`,
                            instName: `Pamo Universitv o Medica Sciences.`,
                            instAddress: `Port Harcourt. Rivers State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PAUL`,
                            instName: `Pau University. Awka`,
                            instAddress: `P.M.B. 6074, Awka Anambra State`,
                            instPhone: [`017121728`, `01-4405524`, `09027123426`],
                            email: [`into@pauluniversity.edu.ng`],
                            website: [`www.pauluniversitv.edu.ng`]
                        },
                        {
                            abbreviation: `PAN-ATLANTIC`,
                            instName: `PAN-ATLANTIC University`,
                            instAddress: `KM 52, Lekki - Epe Express Way, Ibeju - Lekki, Lagos.`,
                            instPhone: [`01-7121728`, `01-4405524`, `09027123426`],
                            email: [`info@pau.edu.ng`, `admissions@pau.edu.ng`],
                            website: [`www.pau.edu.ng`]
                        },
                        {
                            abbreviation: `PC-UNI`,
                            instName: `Precious CornerStone University`,
                            instAddress: `Ibadan, Oyo state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PEACELAND UNI`,
                            instName: `Peaceland University`,
                            instAddress: `Enugu, Enugu State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PETER-UNI`,
                            instName: `Peter University`,
                            instAddress: `Achina-Unnen, Anambra State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PHILOMATH`,
                            instName: `Philomath University`,
                            instAddress: `Agwada Nasarawa state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PRIME-UNI`,
                            instName: `Prime University`,
                            instAddress: `Kuje, Abuja.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PRU`,
                            instName: `Pen Resource University`,
                            instAddress: `Gombe, Gombe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `RHEMA`,
                            instName: `Rhema University, Aba Take-off Site,`,
                            instAddress: `No. 153/155, Aba - Owerri Road, Aba, P.M.B. 7021, Aba, Abia State.`,
                            instPhone: [`07028544572`, `082865276`],
                            email: [`registrar rhemauniversity@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `REDEEMERS`,
                            instName: `Redeemers University`,
                            instAddress: `P.M.B. 230, Ede. Osun State`,
                            instPhone: [`01-8502921`, `08023978672`],
                            email: [``],
                            website: [`www.run.edu.ng`]
                        },
                        {
                            abbreviation: `RENAISSANCE`,
                            instName: `Renaissance univeSItY, Ugbawka`,
                            instAddress: `Enugu state P.M.B. 1019, Enugu`,
                            instPhone: [`08036023768`],
                            email: [`Registrar@rnu.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `RITMAN`,
                            instName: `Ritman University`,
                            instAddress: `IkOt-ckpene, Akwa ibom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAISA`,
                            instName: `Saisa Universitv of vedica sciences and Technology,`,
                            instAddress: `sOkoto sokoto state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SALEM`,
                            instName: `Salem University`,
                            instAddress: `KM 16, Lokoja-Ajaokuta Road P.M.B. 1060. Lokoia. Kogi State`,
                            instPhone: [`08072881598`, `07033480414`, `08081242631`],
                            email: [`registrar@salemuniversity.edu.ng`, `vicechancellor@salemuniversity.eau.ng`],
                            website: [`www.salemuniversity.edu.ng`]
                        },
                        {
                            abbreviation: `SAU`,
                            instName: `Samuel Adegboyega University, ogwa`,
                            instAddress: `ogwa, Edo State`,
                            instPhone: [`08034330353`, `08082913202`, `08033490946`],
                            email: [`sauict@yahoo.com`],
                            website: [`www.sau.edu.ng`]
                        },
                        {
                            abbreviation: `SAM-MARIS`,
                            instName: `Sam Maris University`,
                            instAddress: `supare-Акоко, Ondo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAUED`,
                            instName: `Sultan Abubakar University of Education, Tambuwal,`,
                            instAddress: `Sokoto State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SARUED`,
                            instName: `Sa adatu Rimi University of Education.`,
                            instAddress: `Kumbotso, Kano state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SKYLINE`,
                            instName: `SkYline University Nigerla`,
                            instAddress: `Kano, Kano state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SOUTHWESTERN`,
                            instName: `Southwestern University`,
                            instAddress: `Okun-Owa. Ogun state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SPIRITAN`,
                            instName: `spiritan University`,
                            instAddress: `Nneochi. Ajali-hube Road Leru Junction, Abia state`,
                            instPhone: [`+2348114118277`, `+2348080906775`],
                            email: [`Info@spiritanuniversity.edu.ng`],
                            website: [`www.spiritanuniversitv.edu.ng`]
                        },
                        {
                            abbreviation: `SPORTS-UNI`,
                            instName: `Sports University`,
                            instAddress: `Idumeje Ugooko, Delta state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SUMMIT`,
                            instName: `summit University`,
                            instAddress: `Offa, Kwara state, P.M.B. 4412. Offa.`,
                            instPhone: [`08030981930`],
                            email: [`vcsummituniversity@email.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `TANSIAN`,
                            instName: `Tansian University`,
                            instAddress: `P.O. BOX375. Oba Anambra state`,
                            instPhone: [`0806974789`, `08052222875`, `046-302390`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TAU`,
                            instName: `Thomas Adewumi university`,
                            instAddress: `Oko-Irese Kwara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TOPFAITH`,
                            instName: `Topfaith University.`,
                            instAddress: `Mkpatak, Akwa Ibom state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TRINITY`,
                            instName: `Trinity University.`,
                            instAddress: `yaba, Lagos State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNIHEZ`,
                            instName: `Hezekiah University`,
                            instAddress: `Umudi, P.M.B. 3002, Nkwerre, Imo state`,
                            instPhone: [``],
                            email:[`vc@hezekiah.edu.ng`, `admissions@hezeklan.edu.ng`],
                            website: [`www.nezeklan.edu.ng`]
                        },
                        {
                            abbreviation: `UNINIGER`,
                            instName: `University On The Niger.`,
                            instAddress: `Umunya, Anambra sire`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNIKINGS`,
                            instName: `Kings University`,
                            instAddress: `Gbongan-Osogbo Road, P.M.B 555,Ode-Umu, Osun State`,
                            instPhone: [``],
                            email: [`registrar@kingsuniversity.edu.ng`],
                            website: [`www.kingsuniversity.edu.ng`]
                        },
                        {
                            abbreviation: `UOO`,
                            instName: `Universitv of Offa.`,
                            instAddress: `Offa, Kwara state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `VISION-UNI`,
                            instName: `vision University`,
                            instAddress: `Ado-odo. Ikogbo lown, Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WELLSPRING`,
                            instName: `Wellspring University`,
                            instAddress: `Evbuobanosa, P. M.B. 1230 Benin City. Edo State`,
                            instPhone: [`07042683282`, `08191189031`],
                            email: [``],
                            website: [`www.springuniversity.net`]
                        },
                        {
                            abbreviation: `WESTERN-DEL`,
                            instName: `Western Delta University`,
                            instAddress: `Oghara, Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [`westerndeltauni@yahoo.com`]
                        },
                        {
                            abbreviation: `WESTLAND`,
                            instName: `westland University`,
                            instAddress: `Iwo, Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WESLEYUNI`,
                            instName: `Wesley University`,
                            instAddress: `Ondo, P.M.B 507, Ondo-Ife Road, Ondo`,
                            instPhone: [`034-204395`],
                            email: [`wustondo_vc@mai2methodist.com`, `Wutondo_vc@yahoo.com`],
                            website: [`www.wusto.com`]
                        },
                        {
                            abbreviation: `WIGWE`,
                            instName: `wigwe University`,
                            instAddress: `Isiokpo,Rivers state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `VERITAS`,
                            instName: `Veritas University`,
                            instAddress: `Abuja`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `VENITE`,
                            instName: `venite University`,
                            instAddress: `Ikoro Ekiti, Ekiti State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 11,
                    sectionTitle: `K. OTHER DEGREE AWARDING INSTITUTIONS`,
                    contents: [
                        {
                            abbreviation: `ADEYEMIDEC`,
                            instName: `Adeyemi College of Education, Obafemi Awolowo University Osun State`,
                            instAddress: `P.M.B 520. Ondo.`,
                            instPhone: [`034-610050`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ARGUNGU-DEG`,
                            instName: `Adam Augle college of Education, usmanu Danfodiyo University`,
                            instAddress: `Argungu`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AUCHIPOLY-DEG`,
                            instName: `Auchi Polytechnic, Auchi, Nnamdi Azikiwe University,`,
                            instAddress: `Auchi, Edo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDALV`,
                            instName: `Alvan Ikoku Federal College of Education, Universitv of Nigeria Nsukka`,
                            instAddress: `Owerri, Imo State P.M.B 10033`,
                            instPhone: [`083-230300`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDKAN`,
                            instName: `Federa College of Education, Amahdu Bello UNiversity`,
                            instAddress: `P.M.B.3045, Kano`,
                            instPhone: [`064-633101`, `623101`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDZAR`,
                            instName: `Federal College of Education, Amahdu Bello UNiversity`,
                            instAddress: `P.M.B.1041, Zaria, Kaduna state`,
                            instPhone: [`069-33106,335085,332082,`, `08037015076`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KADPOLY-FUTM`,
                            instName: `Kaduna Polvtechnic, Federal University of Technology, Minna`,
                            instAddress: `P.M.B 2021. Kaduna.`,
                            instPhone: [`062-211511`, `211582`, `211673`, `211744`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `YABA-DEG`,
                            instName: `Yaba College of Technology, University of Nigeria, NSUkka Enugu`,
                            instAddress: `P.M.B 2011. Yaba _Lagos`,
                            instPhone: [`01/800160-4`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AGBORCOE`,
                            instName: `College of Education, Agbor,Delta State University, Abraka,`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AICI`,
                            instName: `Adams ebudu Christian Institute, Universitv of Port Harcourt,`,
                            instAddress: `Emevor, Delta state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AIM`,
                            instName: `Augustina institute, Benue State University,`,
                            instAddress: `Makurdi, Benue state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AOCOE`,
                            instName: `Adeniran Ogunsanva college of Education, EKItI State University.`,
                            instAddress: `Otto/lianikin. Lagos`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `APOSTOLIC`,
                            instName: `The Apostolic Church Theological seminary, Amumara, Universitv of Uvo.`,
                            instAddress: `P.O.Box 5. Amumara. Ezinihitte, Mbaise, Imo state`,
                            instPhone: [``],
                            email: [`tactsa@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `ASHIPOLY-DEG`,
                            instName: `Ashi Polvtechnic, Anyin, Benue state university,`,
                            instAddress: `Makurdi, Benue state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ASPOL-DEG`,
                            instName: `Adamawa State Polvtechnic, University of Maiduguri`,
                            instAddress: `Yola`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ASSEMBLIES`,
                            instName: `Assemblies of GOd Divinity School, University of Uyo`,
                            instAddress: `Old Umuahia`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ATAPOLY-DG`,
                            instName: `Abubakar Tatari Al Polytechnic, Abubakar Tafawa balewa`,
                            instAddress: `Bauchi`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AVCTA`,
                            instName: `Archbishop Vining College of Theology, Akure, University of Ibadan.`,
                            instAddress: `Akure P.M.B 727`,
                            instPhone: [``],
                            email: [`viningdeansec@yahoo.co.uk`],
                            website: [``]
                        },
                        {
                            abbreviation: `BAPTIST`,
                            instName: `baptist college of Theology, University of Port Harcourt,`,
                            instAddress: `ObInze, Owerri`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BCT-BENIN`,
                            instName: `Baptist College of Theology, Ambrose Ali University`,
                            instAddress: `benin city, edo state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BMSE`,
                            instName: `BIgard Memorial seminary, University of Ibadan,`,
                            instAddress: `Enugu.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CAILS`,
                            instName: `College of Arabic and Islamic Legal studies, Bayero University`,
                            instAddress: `Ilorin`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CALVARY`,
                            instName: `Calvary College of Theology, University of calabar,`,
                            instAddress: `Rukpokwu, ObIo, Port Harcourt`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CE-AKWANGA`,
                            instName: `College of Education, Ahmadu Bello University.`,
                            instAddress: `Akwanga, Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HONG-DEG`,
                            instName: `College of caucation. Hong, Ahmadu Bello University,`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CISATA`,
                            instName: `Catholic Institute of West Africa, University of Calabar,`,
                            instAddress: `Port Harcourt`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CLARETIAN`,
                            instName: `claretian Institute of Philosophy, Imo State University,`,
                            instAddress: `Nekede`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COEA`,
                            instName: `Aminu Saleh College of Education, Universitv of Maiduguri.`,
                            instAddress: `Azare`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CST-NDU`,
                            instName: `College of seminarv and Theology, Niger Delta University,`,
                            instAddress: `Irri, Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DIAMOND-DEG`,
                            instName: `Diamond College of Eduaction, Enugu State University of Science and Technology.`,
                            instAddress: `Aba, Abia State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EACOE`,
                            instName: `Emmanuel Alayande College of Education, Ekiti State University`,
                            instAddress: `Oyo`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ECWA`,
                            instName: `ECWA Theological Seminary, UniversiTy of Ibadan.`,
                            instAddress: `Igbaja`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COED-DEG`,
                            instName: `Isa Kaita College of EduCaTiOn, Ahmadu Bello University.`,
                            instAddress: `Dutsinma, Katsina State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDANKPA`,
                            instName: `College of Fducation. Ankpa, Abubakar Tafawa balewa`,
                            instAddress: `P.M.B. 1033, Ankpa, Kogi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDAKOKA`,
                            instName: `Federal College of Education (Technical), UniversiTy of Benin.`,
                            instAddress: `Akoka, Lagos`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDASAB`,
                            instName: `Federal College of Education (Technical), University of Benin.`,
                            instAddress: `Asaba`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDOBUDU`,
                            instName: `Federal College of Education, University of Calabar`,
                            instAddress: `Obudu Cross River State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDGUSAU(T)`,
                            instName: `Federal College of Education (Technical), Ahmadu Bello University`,
                            instAddress: `Gusau`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDUMUNZ`,
                            instName: `Fed College of Educ. (Tech.), Nnamdi Azikwe University`,
                            instAddress: `Umunze, P.M.B. 0189, Umunze, Anambra State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDOMOK`,
                            instName: `Fed College of Educ. (Tech.), University of Nigeria`,
                            instAddress: `Omoku, Omoku, Rivers State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDOMOK-UYO`,
                            instName: `Federal college of education (Technical), University of Uyo`,
                            instAddress: `Omoku. P.M.B. 11. Omoku. Rivers State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDYOLA`,
                            instName: `Federal College of Education, Yola, UniversiTy of Maiduguri`,
                            instAddress: `Yola, Adamawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDGUMEL`,
                            instName: `Jigawa state college of Education, Bayero University`,
                            instAddress: `Gumel, P.M.B. 1002. Jigawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDKANO`,
                            instName: `Saadatu Rimi College of education, Bayero University`,
                            instAddress: `Kumbotso Zaria Rd Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EDKANO-2`,
                            instName: `Saadatu Rimi College of education, Ahmadu Bello University.`,
                            instAddress: `Kumbotso Zaria Rd Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EL-TAYEB`,
                            instName: `Sheik Ibrahim El-tayeb Institute, Bayero University`,
                            instAddress: `Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EMIRATES-D`,
                            instName: `Emirates Collece of Health Sciences and Technology, Kwara State UniversiTy`,
                            instAddress: `Kano`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPOBID-DEG`,
                            instName: `Federal Polvtechnic. Bida, brahim Badamasi Babangida University,`,
                            instAddress: `Niger State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OYOSPECIAL`,
                            instName: `Federa College of Education (special), University of Ibadan,`,
                            instAddress: `oyo, oyo state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ESCOE`,
                            instName: `Enugu State College of Education, (Technical),`,
                            instAddress: `University of Nigeria, Nsukka,`,
                            instPhone: [`Enugu state`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FC-KATSINA`,
                            instName: `Federal College of Education, Bayero University,`,
                            instAddress: `Katsina`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FC-GOMBE`,
                            instName: `Federal College of Education (Technical), Abubakar Tafawa Balewa`,
                            instAddress: `Gombe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FTGOMBE-DEG`,
                            instName: `Federal College of Education, (Technical), Usmanu Danfodiyo University`,
                            instAddress: `Gombe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FC-KONTAGORA`,
                            instName: `Federal College of Education, Kontagora, Ahmadu Bello University`,
                            instAddress: `Kontagora`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FC-PANKSHIN`,
                            instName: `Federal College of Education, Pankshin, University of Jos`,
                            instAddress: `Pankshin`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FCDTT-FUTO`,
                            instName: `Federal College of Dental Technology and Therapy, Federal University of Technology, Owerri.`,
                            instAddress: `Enugu, Enugu, state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPOADO-D`,
                            instName: `Federal Polytechnic, Ado-Ekiti, Federal University of Technology, Minna.`,
                            instAddress: `Ado-Ekiti, Ekiti State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        }, 
                        {
                            abbreviation: `ILA-ORANGUN`,
                            instName: `Osun State College of Education. Ila-Orangun, Ekiti State University.`,
                            instAddress: `Ila-Orangun`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FC-ABEOKUTA`,
                            instName: `Federal College of Education, Abeokuta, University of Ibadan`,
                            instAddress: `Abeokuta. Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FCOKENEDEG`,
                            instName: `Federal College of Education, Okene, Universitv of Ibadan.`,
                            instAddress: `Okene, Kogi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FTBICHI-DEG`,
                            instName: `Federal College of Education Technical, bichl, Abubakar Tafawa Balewa University`,
                            instAddress: `Bichi, Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FCEKANO-DEG`,
                            instName: `Federa College of Education, Kano, Usmanu Danfodiyo University,`,
                            instAddress: `Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FCEZARIA-DEG`,
                            instName: `Federa College of Education, Zaria, Usmanu Danfodiyo University`,
                            instAddress: `Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COFRINGIM-DEG`,
                            instName: `ligawa state college of education and Legal studies, Ringim, Usmanu Danfodiyo University`,
                            instAddress: `JIgawa state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COEMARU-DEG`,
                            instName: `Zamfara State College оf Education, Maru, Usmanu Danfodiyo University`,
                            instAddress: `Zamfara State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GIDANWAYA-DEG`,
                            instName: `College of Fducation. Gidan waya, Ahmadu Bello University`,
                            instAddress: `P.M.B. 1024. Katanchan, Kaduna state`,
                            instPhone: [`061-20229`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GITS`,
                            instName: `Gindiri Theological Seminary, University of Jos,`,
                            instAddress: `Plateau State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HARVEST`,
                            instName: `World Harvest Bible College and Seminary, University of Calabar,`,
                            instAddress: `Calabar`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UBCOF-DEG`,
                            instName: `Issac Jasper Boro college of Education., Niger Delta University,`,
                            instAddress: `jaguama, Bayelsa State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IMMANUEL`,
                            instName: `Immanuel college of Theology and Christian Education, Samoda, University of Ibadan`,
                            instAddress: `Samoda, Ibadan`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IKERE-EKITI`,
                            instName: `College of Education. Ikere, University of Nigeria,`,
                            instAddress: `Ikere Ekiti`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IKWO-DEG`,
                            instName: `cbonvi State college 0f Education. ikwo, Ebonyi state University`,
                            instAddress: `ikwo`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `JETS`,
                            instName: `Jos ECWA Theological Seminary, University of Jos`,
                            instAddress: `Jos, Plateau state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KAT-ALA DEG`,
                            instName: `college of education, Katsina-Ala, University of calabar`,
                            instAddress: `Benue State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KICOE-DEG`,
                            instName: `Kashim Torahim College of Education, University of Maiduguri.`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ILORINCOL-DEG`,
                            instName: `Kwara State College of education, Universitv of ilorin,`,
                            instAddress: `Ilorin, KWara StaTE`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LTS`,
                            instName: `Life Theological Seminary, University of Ibadan`,
                            instAddress: `Lagos`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `METHODIST`,
                            instName: `Methodist Theological Institute. Umuahia, Universitv of Port Harcourt.`,
                            instAddress: `Umuahia`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MINILS-DEG`,
                            instName: `Michael Imodu National Institute for Labour Studies, University of Ilorin`,
                            instAddress: `Ilorin`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MOCPEN`,
                            instName: `Michael Otedola College of Primary Education Noforiia Epe, University of Ibadan`,
                            instAddress: `Epe, Lagos`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MOSOGAR-DEG`,
                            instName: `Delta State College of Physical Education, Mosogar, Universitv of Benin`,
                            instAddress: `Mosogar`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MOSOGA-DG2`,
                            instName: `College of Physical Education, Mosogar, Delta State University.`,
                            instAddress: `Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KWCOE`,
                            instName: `kwara state college of Education. Technical, Ahmadu Bello University.`,
                            instAddress: `Lafiagi.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NATIONAL`,
                            instName: `National Missionary seminary of St-Paul, University of Port Harcourt.`,
                            instAddress: `Gwagwalada`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NBTSO`,
                            instName: `Nigeria Baptist Theological Seminarv. Ogbomosho, University of Ibadan.`,
                            instAddress: `Ogbomosho`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NCBC`,
                            instName: `Nigerian Christian Bible College. Ukpom, University of Calabar`,
                            instAddress: `Ukoom. P.M.B. 1040. Abak, Akwa Ibom state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NFI-DEG`,
                            instName: `National rim Institute, Jos, University of Jos`,
                            instAddress: `Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NSCOF-DEG`,
                            instName: `Niger State College of Education Minna, Usmnanu Danfodiyo University`,
                            instAddress: `Minna`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NTA-TVC`,
                            instName: `National Teachers Institute, Kaduna, University 0f Maiduguri.`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NSUGBE`,
                            instName: `Nwator Orizu college of Education, University of Nigeria.`,
                            instAddress: `Nsugbe`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OJU-DEG`,
                            instName: `College of Education. Oju, Benue State University.`,
                            instAddress: `Otukoo. Benue State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OSCOE`,
                            instName: `usun state college of Education. Ilesa, University of Ibadan`,
                            instAddress: `Ilesa`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PACOT`,
                            instName: `Peter Achimugu College of Theology, Kogi State University,`,
                            instAddress: `Ankpa`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POPE`,
                            instName: `Pope john Major seminary, Nnamdi Azikiwe University,`,
                            instAddress: `Okpun, Awka`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POTISKUM_D`,
                            instName: `Federal College of Education, (Technical), Potiskum, Abubakar Tafawa Balewa`,
                            instAddress: `Potiskum`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PTC`,
                            instName: `Essien Ukpabio Presovterian Theologica College. itu, Universitv of Calabar`,
                            instAddress: `Akwa Ibom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `REDEEMED`,
                            instName: `Redeemed christian Bible college, Redemption camp, University of Ibadan`,
                            instAddress: `Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `RUFAI-DEG`,
                            instName: `A.D. Rutai Colleçe for Legal and islamic Studies, Bayero University.`,
                            instAddress: `Bauchi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAMUEI`,
                            instName: `The Samue Bill Theological College, University of Uyo`,
                            instAddress: `Abak. Akwa Ibom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAMS`,
                            instName: `St. Augustine's Maior Seminary, University of Jos`,
                            instAddress: `Jos, Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SBS`,
                            instName: `Schoo of Biblica Studies. Jos, University of Jos`,
                            instAddress: `Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SITECH-DEG`,
                            instName: `Savannah Institute of Technology, Federal University, wukari`,
                            instAddress: `Abakaliki, Ebonyi state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SHAGARI`,
                            instName: `Shehu Shagari College of Education, Ahmadu Bello University`,
                            instAddress: `Sokotc`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SHAGARI-2`,
                            instName: `Shehu Shagari College of Education, Usmanu Danfodiuyo university.`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SPIRITAN-ENU`,
                            instName: `Spiritan Int'l School of Theology, University of Nigeria,`,
                            instAddress: `Attakwu, Enugu`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SPIRITAN-NSK`,
                            instName: `Spiritan School of Philosophy, University of Nigeria`,
                            instAddress: `Issienu, Nsukka`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SACOED B.ED`,
                            instName: `St. Augustines college of Education, University of Ibadan.`,
                            instAddress: `Akoka. Lagos.`,
                            instPhone: [`01-793-3594`],
                            email: [`staugustinecollege@vahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `ST-ALBERT`,
                            instName: `St. Albert The Great Major Seminary, University of Benin`,
                            instAddress: `Abeokuta`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAIK`,
                            instName: `St. Albert Institute Favit Fadan, University of Jos`,
                            instAddress: `Kafanchan, PMB 1006 Kaduna State`,
                            instPhone: [`07067177375`,`09043201080`],
                            email: [`stalbertinstitute1@gmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `ST-JOSEPH`,
                            instName: `st-Joseph Major seminary.`,
                            instAddress: `Ikot- Ekpene. Akwa ibom State, University of calabar`,
                            instPhone: [`08124057936`],
                            email: [`registrarstioseph@email.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `ST PETER & PAUL`,
                            instName: `St. Peter and Paul Seminary Bodija, University of Ibadan,`,
                            instAddress: `Ibadan`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SWSO`,
                            instName: `Seat of Wisdom Seminary, Imo State University,`,
                            instAddress: `Owerri`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TONN`,
                            instName: `Theological College of Northern Nigeria, University of Jos,`,
                            instAddress: `Jos. Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TTC`,
                            instName: `Trinity Theological College, Universitv of Nigeria`,
                            instAddress: `Umuahia.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UHIELE`,
                            instName: `Seminary of All Saints. Uhiele`,
                            instAddress: `Universitv of Benin`,
                            instPhone: [`Ekooma. Edo State`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UMCA`,
                            instName: `United Missionary Church of Africa Theological School (UMCA), University of Ibadan`,
                            instAddress: `Ilorin`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UMAR`,
                            instName: `Umar ibn Ibrahim El-Kanemi College of education. science and Technology, Bama, University of Maiduguri.`,
                            instAddress: `Borno State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `USCOE`,
                            instName: `Umar Suleiman College of Education, Universitv of Maiduguri`,
                            instAddress: `Gashua, Yobe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UUST`,
                            instName: `Uma Ukpai School of Theology, Uyo, University of Uyo,`,
                            instAddress: `Akwa Ibom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `VOM-DEG`,
                            instName: `College of Animal Health and Production Technology, Abubakar Tafawa Balewa`,
                            instAddress: `vom, Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WARRI`,
                            instName: `College of Education, Warri, Delta State University,`,
                            instAddress: `Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WARRICOE-DEG`,
                            instName: `College of Education. Warri, University of Benin`,
                            instAddress: `Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WATSI`,
                            instName: `West Africa Theological Seminary, University of Nigeria.`,
                            instAddress: `Ipaja, Lagos`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ZING-DEG`,
                            instName: `College of Education Zing, Ahmadu Bello University`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AMUFU-DEG`,
                            instName: `Federal College of Education, Eha-Amura, University of Nigeria`,
                            instAddress: `Enugu state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KWCOE-DEG`,
                            instName: `Kwara State College of Education, Ekiti State university`,
                            instAddress: `ilorin`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GUSAU-DEG`,
                            instName: `Federal College of Education (Technical), Gusau, Federal University of Technology`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WAKABIU-DEG`,
                            instName: `College of Education, Waka-Biu, University of Maiduguri`,
                            instAddress: `Borno State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AKSCOE-DEG`,
                            instName: `Akwa Ibom State College of Education, University of Uyo`,
                            instAddress: `Afaha-Nsit`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ORO-DEG`,
                            instName: `Kwara State College of Education, Ekiti State University`,
                            instAddress: `oro, Kwara`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IMTENU-DEG`,
                            instName: `Institute of Management and Technology, University of Nigeria`,
                            instAddress: `Enugu`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AKAMKPA-DEG`,
                            instName: `Cross River State College of Education, Universitv of Calabar`,
                            instAddress: `Akamkpa,Cross River `,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KADPOLY-ABU`,
                            instName: `kaduna Polytechnic, Ahmadu Bello University`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IJEBUODE-DEG`,
                            instName: `Tai Solarin College of Education, Olabisi Onabanjo University`,
                            instAddress: `ijebu Ode. Ogun state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BIDA-DEG`,
                            instName: `Federal Polytechnic. Bida, Federal Universitv of Technology, Minna`,
                            instAddress: `Niger State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OFFA-DEG`,
                            instName: `Federal Polytechnic, Offa, Federal Universitv of Technology, Minna`,
                            instAddress: `Offa, Kwara state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KATPOLY-DEG`,
                            instName: `Hassan Usman Katsina polythechnic, Federal Universitv of Technology, Minna`,
                            instAddress: `Katsina State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPOBAU-DEG`,
                            instName: `Federal Polytechnic. Bauchi, Abubakar Tafawa Balewa`,
                            instAddress: `Bauchi`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NASE-DEG`,
                            instName: `Nigerian Army School of Education, Tai Solarinm University ofm Education,`,
                            instAddress: `Ilorin`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ZUBA-DEG`,
                            instName: `FCT College of Education. Zuba, Ahmadu Bello University`,
                            instAddress: `Zuba, Abuja`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 12,
                    sectionTitle: `L. E-LEARNING UNIVERSITIES OF NIGERIA (ELUON)`,
                    contents: [
                        {
                            abbreviation: `MAIDUGURI-ELUON`,
                            instName: `University of Maiduguri`,
                            instAddress: `Maiduguri`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NOUN-ELUON`,
                            instName: `National Open University of Nigeria, University Village`,
                            instAddress: `Plot 91, Cadastral Zone, Nnamdi Azikiwe Express Way, Jabi, Abuja`,
                            instPhone: [`08082629830`],
                            email: [`registrar@noun.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `UDU-ELUON`,
                            instName: `Usmanu Danfodiyo University`,
                            instAddress: `Sokoto`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UYO-ELUON`,
                            instName: `University of Uyo`,
                            instAddress: `Uyo`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 13,
                    sectionTitle: `M. INSTITUTIONS WITH SANDWICH PROGRAMMES`,
                    contents: [
                        {
                            abbreviation: `MAID-SDWCH`,
                            instName: `University of Maiduguri Sandwich Programme`,
                            instAddress: `Maiduguri, Borno State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        }
                    ]
                },
                {
                    id: 14,
                    sectionTitle: `N. INSTITUTIONS WITH OPEN AND DISTANCE LEARNING PROGRAMMES`,
                    contents: [
                        {
                            abbreviation: `ABU-ODL`,
                            instName: `Ahmad Bello University Open and Distance Learning Programme`,
                            instAddress: `Zaria, Kaduna state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ILORIN-ODL`,
                            instName: `University of Ilorin centre for open Distance and e-Learning,`,
                            instAddress: `ilorin kwara state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
            ]
        },
        {
            id: 1,
            contentSectionName: 'Specific Entry Requirements',
            contentPdf: ``,
            contentFile: specificEntry,
        },
        {
            id: 3,
            contentSectionName: 'Administration',
            contentPdf: ``,
            contentFile: administration,
        },
        {
            id: 4,
            contentSectionName: 'Agriculture',
            contentPdf: ``,
            contentFile: agriculture,
        },
        {
            id: 5,
            contentSectionName: 'Arts / Humanities',
            contentPdf: ``,
            contentFile: arts,
        },
        {
            id: 6,
            contentSectionName: 'Engineering / Enviromental / Technology',
            contentPdf: ``,
            contentFile: engineering,
        },
        {
            id: 7,
            contentSectionName: 'Education',
            contentPdf: ``,
            contentFile: education,
        },
        {
            id: 8,
            contentSectionName: 'Law',
            contentPdf: ``,
            contentFile: law,
        },
        {
            id: 9,
            contentSectionName: 'Medica/Pharmaceutical Health Science',
            contentPdf: ``,
            contentFile: medical,
        },
        {
            id: 10,
            contentSectionName: 'Sciences',
            contentPdf: ``,
            contentFile: sciences,
        },
        {
            id: 11,
            contentSectionName: 'Social Management Science',
            contentPdf: ``,
            contentFile: social,
        },
    ]
 }
]